// extracted by mini-css-extract-plugin
module.exports = {"sharePost__wrapper":"StartPostButton_sharePost__wrapper__K_1cO","text":"StartPostButton_text__TJptX","sendIcon":"StartPostButton_sendIcon__GPYVn"};